<!--
 * @Date: 2020-03-03 15:15:45
 * @Author: WZ
 * @Description: 沙箱环境
-->
<template>
  <div class="sandbox">
    <el-collapse v-model="activeName">
      <el-collapse-item v-for="item in tableList" :title="$lang(item.title)" :name="item.value" :key="item.value">
        <template #title v-if="item.value == 1">
          <p>
            {{ $lang(item.title) }}<span class="title_sub">{{$lang('保存30天内的数据')}}</span>
          </p>
        </template>
        <el-table border :data="filterData[item.value]" style="width: 100%;border-radius:4px;">
          <el-table-column type="index" :label="$lang('序号')" align="center" width="100">
          </el-table-column>
          <el-table-column prop="name" align="center" :label="$lang('API名称')">
            <template slot-scope="{ row }">
              {{ $lang(row.name) }}
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$lang('接口地址')" v-if="status == 0" width="350">
            <template slot-scope="{ row }">
              {{apiBaseUrl + row.url + uuidNew}}
            </template>
          </el-table-column>
          <el-table-column prop="testUrl" align="center" :label="$lang('接口地址')" v-if="status == 1 && item.value == 1" width="320">
          </el-table-column>
          <!-- 注册类-未联调接口地址可填 -->
          <el-table-column align="center" :label="$lang('接口地址')" v-if="status == 1 && item.value == 2" width="320">
            <template slot-scope="{ row }">
              <el-input v-model="row.testUrl" style="width: 290px;"></el-input>
            </template>
          </el-table-column>
          <!-- 注册类才有操作一栏 -->
          <el-table-column align="center" :label="$lang('操作')" v-if="status == 1">
            <template slot-scope="{ row }">
              <el-button :loading="isLoading1" type="text" v-if="row.testNum >= 3" @click="revoke(row)">{{$lang('撤销')}}</el-button>
              <el-button :loading="isLoading2" type="text" v-else @click="test(row)">{{$lang('调试')}}</el-button>
            </template>
          </el-table-column>
          <el-table-column v-if="item.value == 1" prop="testTime" align="center" :label="$lang('调用时间')" width="180">
          </el-table-column>
          <!-- 订阅类状态，testNum等于1是成功 -->
          <el-table-column align="center" :label="$lang('状态')" v-if="status == 0">
            <template slot-scope="{ row }">
              {{ row.testNum | statusFilter1 }}
            </template>
          </el-table-column>
          <!-- 订阅类状态，testNum等于3是成功 -->
          <el-table-column  align="center" :label="$lang('状态')" v-if="status == 1">
            <template slot-scope="{ row }">
              {{ row.testNum | statusFilter2 }}
            </template>
          </el-table-column>
          <el-table-column prop="reason" align="center" :label="$lang('原因')" v-if="status == 1 && item.value == 2" width="150">
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>

  </div>
</template>

<script type="text/javascript">
import { RESPONSE_SUCCESS } from "@/constants"
import { mapGetters } from "vuex"
import {OPEN_API_TEST_NEW } from '@/constants/index'
import {lang} from "@utils/filters"
export default {
  name: "Sandbox",
  props: {
    status: {
      type: [Number, String],
      default: 0,
    },
  },
  components: {},
  filters: {
    //过滤器的配置项
    statusFilter1: function(val) {
      // testNum 大于等于3 才算联调成功
      return val >= 1? lang('成功') : lang('未联调')
    },
    statusFilter2: function(val) {
      // testNum 大于等于3 才算联调成功
      return val >= 3? lang('成功') : lang('未联调')
    },
  },
  data() {
    return {
      activeName: ["1", "2"],
      tableList: [
        { title: lang("联调成功"), value: "1" },
        { title: lang("未联调"), value: "2" },
      ],
      dataList: [],
      isLoading1: false,
      isLoading2: false,
      apiBaseUrl: OPEN_API_TEST_NEW
    }
  },
  computed: {
    ...mapGetters(["user", "uuid"]),
    filterData() {
      return {
        // 状态-0:订阅类，1:注册类
        // 订阅类 testNum等于1，算成功
        // 注册类 接口测试超过等于3次 才算联调成功
        1: this.dataList.filter(
                                                          // 注册类大于等于3 成功        // 订阅类 调试成功次数大于等于1 成功
                                                          //       ↓                             ↓
          (item) => item.interfaceType == this.status && (item.testNum >= 3 || (item.interfaceType == 0 && item.testNum >= 1))
        ),
        2: this.dataList.filter(
          (item) => item.interfaceType == this.status && ((item.interfaceType == 1 && item.testNum < 3) || (item.interfaceType == 0 && item.testNum < 1))
        )
      }
    },
    uuidNew() {
      return this.uuid.length > 0 ? `?uuid=${this.uuid}` : ''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /**
     * @description 获取列表
     */
    getList() {
      this.$API.getInterfaceList().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          const dataList = [...res.data]
          dataList.map((currentValue,index,arr)=>{
            arr[index] = {...arr[index], name:this.$t(currentValue.name)}
          })
          this.dataList = [...dataList]
          console.log(this.dataList)
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    /**
     * @description 申请
     */
    test(row) {
      // 如果用户没有输入测试地址，提醒并且终止向下执行
      if(!row.testUrl || row.testUrl.length === 0) {
        this.$message.warning(this.$lang('请输入接口地址'))
        return
      }
      this.isLoading2 = true
      const params = {
        id: row.interfaceId,
        urlCallback: row.testUrl,
        userId: this.user.id,
      }
      this.$API.changeStatus(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isLoading2 = false
          // 成功返回的data是"",失败返回的data是"失败原因"，都是字符串
          if (res.data.length > 0) {
            // 失败了-data就是返回的原因，前端需要渲染到对应的行，但是原因一栏后端返回但不存储，一刷新就会消失
            row.reason = res.data
          } else {
            // 成功了-需要判断成功次数，成功次数到达3，重新请求接口列表
            row.testNum ++
            this.$message({
                type: 'success',
                message: `${this.$lang('调试成功')},${this.$lang('已成功')}${row.testNum}${this.$lang('次')}`,
                duration: 800
              })
            // 成功了，清空失败原因
            row.reason = ''
            if(row.testNum == 3) {
              this.getList()
            }
          }
        } else {
          this.isLoading2 = false
          this.$message.error(res.msg)
        }
      })
    },
    /**
     *  撤销
     */
    revoke(row) {
      this.isLoading1 = true
      const params = {
        id: row.interfaceId,
        urlCallback: row.testUrl,
        userId: this.user.id,
      }
      this.$API.revoke(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isLoading1 = false
          this.getList()
          this.$message.success(this.$lang('撤销成功'))
        } else {
          this.isLoading1 = false
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .sandbox::v-deep {
    .editData .el-input {
      width: 100%;
    }
    .title_sub {
      font-size: 12px;
      color: #888888;
      font-weight: 400;
      margin-left: 10px;
    }
    .el-collapse {
      border: none;
    }
    .el-collapse-item__wrap {
      border: none;
    }
    .el-collapse-item__header {
      background: #f9fafc;
      margin-bottom: 10px;
      border: 1px solid $table-border-color;
      border-radius: 4px;
      padding-left: 12px;
      font-weight: 600;
    }
    .el-table .has-gutter th {
      background: #f9fafc;
    }
  }
</style>
